// extracted by mini-css-extract-plugin
export default {"root":"IconDelete_root__qbUxL"};